import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSweetAlert } from "../context/sweetAlertContext";
// import { useAuth } from "../context/AuthContext";

import SampleColorCard from "../components/Card/SampleColorCard";
import ImageSlider from "../components/ImageSlider";
import ImageCard from "../components/Card/ImageCard";
import SidebarPublic from "../components/Sidebar/index-public";
import Help from "./Help";
import { getSetting } from "../services";

import "./dashboard-start.css";

export default function DashboardStart() {
    const navigate = useNavigate();
    // const auth = useAuth();

    const [isOpenHelp, setIsOpenHelp] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const sweetAlert = useSweetAlert();

    const showComingSoon = () => {
        sweetAlert({
            show: true,
            text: "این قابلیت به زودی فعال خواهد شد.",
            confirmButtonText: "باشه",
            marginTop: "20px",
        });
    };

    const alertComingSoon = () => {
        sweetAlert({
            show: true,
            text: `تا اطلاع ثانوی خرید شارژ و اینترنت غیر فعال می‌باشد
    بعد از عقد قراردادهای جدید با اپراتورها و اضافه شدن شدن طرح‌های بیمه مجدداً فعال خواهد شد`,
            confirmButtonText: "مشاهده شد",
            marginTop: "20px",

        })
    }

    const openInvestBimeh = () => {
        const newWindow = window.open('https://investbimeh.ir/', '_blank', 'noopener,noreferrer');
        if (newWindow) {
            newWindow.focus();
        }
    }

    const soon = () => {
        let text = ""

        text = "به زودی ..."

        sweetAlert({
            show: true,
            showCancelButton: false,
            html: `${text}`,
            confirmButtonText: "مشاهده شد",
            marginTop: "20px"
        })
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-12">
                            <ImageSlider />
                        </div>

                        <div className="col-12">
                            <div className="row">
                                <SampleColorCard
                                    name="داشبورد"
                                    width="col-6 mt-0"
                                    color="#ffaf00"
                                    colorClass="button-style1"
                                    publicClass="button-style1"
                                    click={() => navigate("/adv-panel")}
                                />

                                <SampleColorCard
                                    name="راهنما"
                                    width="col-6 mt-0"
                                    color="#ffaf00"
                                    colorClass="button-style2"
                                    publicClass="button-style2"
                                    click={() => setIsOpenHelp(true)}
                                />
                            </div>


                            <div className="row">
                                <ImageCard
                                    image="/icons/social-media-marketing.png"
                                    effect="zoom-in-zoom-out"
                                    name="کسب درآمد از کلیک تبلیغات"
                                    width="col-6 mt-10"
                                    publicClass="cursor-pointer plr-0"
                                    colorClass="bg-white"
                                    click={() => navigate("/adv/show-adv")}
                                />
                                <ImageCard
                                    image="/icons/investBimeh3.png"
                                    effect="zoom-in-zoom-out"
                                    name="کسب درآمد از بیمه"
                                    width="col-6 mt-10"
                                    publicClass="cursor-pointer plr-0"
                                    colorClass="bg-white"
                                    click={() => openInvestBimeh()}
                                />
                            </div>

                            <div className="row">
                                <ImageCard
                                    image="/icons/sim.png"
                                    name="خرید شارژ"
                                    width="col-4 mt-10"
                                    publicClass="cursor-pointer plr-0"
                                    colorClass="bg-white"
                                    click={() => navigate("/charge-sim")}
                                />

                                <ImageCard
                                    image="/icons/internet.png"
                                    name="خرید اینترنت"
                                    width="col-4 mt-10"
                                    publicClass="cursor-pointer plr-0"
                                    colorClass="bg-white"
                                    click={() => navigate("/index-internet")}
                                />

                                <ImageCard
                                    image="/icons/ghobooz2.png"
                                    name="پرداخت قبوض"
                                    width="col-4 mt-10"
                                    publicClass="cursor-pointer plr-0"
                                    colorClass="bg-white"
                                    click={() => navigate("/Gabspeyment")}
                                />
                            </div>

                            <div className="row">
                                <ImageCard
                                    image="/icons/Recipients.png"
                                    name="پذیرندگان"
                                    width="col-6 mt-10"
                                    publicClass="cursor-pointer plr-0"
                                    colorClass="bg-white"
                                    // click={() => showComingSoon()}
                                    click={() => navigate("/recipients/register")}
                                />

                                <ImageCard
                                    image="/icons/shopping-cartpng.png"
                                    name="فروشگاه آنلاین"
                                    width="col-6 mt-10"
                                    publicClass="cursor-pointer plr-0"
                                    colorClass="bg-white"
                                    click={() => navigate("/store/product-categories")}
                                />
                            </div>

                            <div class="row">
                                <ImageCard
                                    image={'/images/bank-services/card-to-iban.png'}
                                    name={"تبدیل کارت به شبا"}
                                    width={'col-4 mt-10'}
                                    publicClass={"cursor-pointer plr-0"}
                                    colorClass={"bg-white"}
                                    click={() => navigate("/card-to-iban")}>
                                </ImageCard>

                                <ImageCard
                                    image={'/images/bank-services/account-to-iban.png'}
                                    name={"تبدیل حساب به شبا"}
                                    width={'col-4 mt-10'}
                                    publicClass={"cursor-pointer plr-0"}
                                    colorClass={"bg-white"}
                                    click={() => navigate("/account-to-iban")}>
                                </ImageCard>
                                <ImageCard
                                    image={'/icons/khodroAndMotor.png'}
                                    name={"خدمات خودرو و موتور"}
                                    width={'col-4 mt-10'}
                                    publicClass={"cursor-pointer plr-0"}
                                    colorClass={"bg-white"}
                                    click={() => navigate("/VehicleServices")}
                                    isComingSoon={true}
                                    >
                                </ImageCard>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            <Help isOpen={isOpenHelp} setIsOpen={setIsOpenHelp} />
        </>
    )
}
